import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { IdentifyMethod } from '@jct/api';
import { ActionState } from '@jct/ui';

import { normalizeIdNumber } from '../identity-form.utils';

@Component({
  selector: 'identity-key-field',
  templateUrl: './identity-key-field.component.html',
})
export class IdentityKeyFieldComponent {
  @Input() form: UntypedFormGroup;
  @Input() loadState: ActionState;

  identifyMethod = IdentifyMethod;

  get method() {
    return this.form.get('method').value;
  }

  get showKeyError() {
    const keyControl = this.form.get('key');
    const value = (keyControl.value ?? '').toString().trim();

    return !!value && keyControl.invalid && keyControl.touched;
  }

  setMethod(method: IdentifyMethod) {
    if (this.method === method) {
      return;
    }

    this.form.get('method').setValue(method);
  }

  onIdNumberInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const digits = normalizeIdNumber(input.value);

    if (input.value !== digits) {
      input.value = digits;
    }

    this.form.get('key').setValue(digits, { emitEvent: false });
    this.form.get('key').updateValueAndValidity({ emitEvent: false });
  }
}
